import { store } from 'rfx-core';

export default store.setup({

});



// WEBPACK FOOTER //
// ./src/stores/index.js